<template>
  <div
    class="content-wrapper"
  >

    <AddNovoColaborador
        :categoria-select="categoriaSelect"
        :endereco-select="enderecoSelect"
        :show-modal="modalColaborador.showModal"
        :exibir-empresa-select="showCompanySelectNewCollaborator"
        :empresa-select="groupCompanies"
        :id-empresa="idCompanyNewCollaborator"
        @confirmed="openModalSucesso"
        @canceled="closeModalColaborador"
        size-modal="lg"
    />

    <ConfirmModalVacinacao
        :modal-show="modalConfirm.showModal"
        :case-modal="modalConfirm.typeModal"
        :pessoa-remover="pessoaRemover"
        :descricao-dose="descricaoDose"
        :tooltip-btn-cancel="modalConfirm.tooltipCancel"
        :disable-cancel="modalConfirm.disableCancel"
        :vacinas-campanha="vacinasCampanha"
        @vacina-selecionada="vacinaSelecionadaHandler"
        @remove="cancelarVacinacao"
        @confirmed="modalConfirm.confirmed"
        @canceled="modalConfirm.canceled"
    />

    <AddNovaVacinacao
        :show-modal="modalVacinacao.showModal"
        :lote-select="loteSelect"
        :doses="modalVacinacao.doses"
        :vacinador-select="vacinadorSelect"
        :endereco-select="addressesNewVaccination"
        :colaborador="modalVacinacao.colaborador"
        :tipoCampanha="campaign.tipo"
        :id-campanha="campaign.idCampaign"
        :empresa="companyNewVaccination"
        :unidade="unitNewVaccination"
        :id-departamento="departamentIdNewVaccination"
        :id-grupo="group.idGroup"
        :exibir-endereco-select="true"
        :vacinas-campanha="vacinasCampanha"
        size-modal="lg"
        @canceled="closeModalVacinacaoCancel"
        @confirmed="openModalSucesso"
    />

    <ModalCancelVacinacao
      :show-modal="modalCancelVacinacao.showModal"
      :pessoa-remover="pessoaRemover"
      @confirmed="cancelarVacinacao"
      @canceled="modalCancelVacinacao.canceled"
      />

    <ModalInformacoesCancelamento
      :show-modal="modalInformacoesCancelamento.showModal"
      :colaborador="modalInformacoesCancelamento.colaborador"
      @canceled="modalInformacoesCancelamento.canceled"
    />

    <ModalCancelarAplicacoesMultiplasDoses
      :show-modal="modalCancelarAplicacoesMultiplasDoses.showModal"
      :colaborador="aplicacoesColaborador"
      :can-exclude="canExclude"
      :isSuporte="isSuporte"
      :isVacinadorPadrao="isVacinadorPadrao"
      :can-cancel-finalized-vaccination="canCancelFinalizedVaccination"
      @close="handleCloseModalCancelarAplicacoesMultiplasDoses"
      @cancelar="handleCancelarMultiplasDoses"
      @estornar="handleEstornarMultiplasDoses"
    />

    <SucessoModal
        :modal-show="modalSucesso.showModal"
        :type-modal="modalSucesso.typeModal"
        :case-modal="modalSucesso.caseModal"
        @confirmed="closeModalSucesso"
    />

    <main class="card hidden_overflow_tabela">
      <div
        class="pt-2"
      >
        <h2 class="h2-descricao-empresa-campanha">
          <span class="span-descricao-empresa">
          {{ this.group.description }} <span v-if="this.company"> - {{this.company.name}} </span>
          </span>
          <span class="font_size_label span-descricao-campanha"
            >{{ moment().format("YYYY")}} - {{ this.campaign.description }} |
            {{ this.unit.description }} </span
          >
        </h2>
        <div class="pt-2 mx-auto col-11">
          <InfoSideCard :data="doses" />
        </div>
      </div>
      <div
        v-if="loadingData"
        class="d-flex justify-content-center my-3"
      >
        <div
          class="spinner-border text-custom-blue"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <hr>
      <section
          v-if="!loadingData && !showFilter"
          class="d-flex align-items-center filters pb-1 px-2"
      >
        <div
            role="button"
            class="mr-auto"
            @click="
              () => {
                showFilter = true;
              }
            "
        >
          <feather-icon
              size="28"
              icon="FilterIcon"
              class="text-custom-blue"
          />
          <span class="ml-1 font-weight-bold text-custom-blue">FILTRAR</span>
        </div>

        <div class="d-flex mr-2">
          <b-form-checkbox v-model="showCollaboratorsAnotherGroup" @input="toogleShowCollaboratorsAnotherGroup"
          />
          <span>
            Exibir colaboradores vacinados em outro grupo
          </span>
        </div>


        <div>

          <b-button
              v-if="canInsertPerson && canManageCollaborators && !isSuporte"
              class="mr-2 cor_botao"
              variant="outline-primary"
              @click="openModalColaborador"
          >
            <feather-icon icon="UserPlusIcon" />
          </b-button>
          <b-button
              v-if="canExport"
              class="mr-2 cor_botao"
              variant="outline-primary"
              @click="downloadSpreadsheet"
          >
            <feather-icon icon="DownloadIcon" />
          </b-button>

        </div>
      </section>
      <section
          v-if="!loadingData && showFilter"
          class="bg-blue filters py-1 px-2"
      >
        <b-row>
          <div
              class="px-1 mr-auto"
              role="button"
              @click="closeFilter"
          >
            <feather-icon
                size="28"
                icon="XIcon"
                class="text-custom-blue"
            />
            <span
                class="ml-1 font-weight-bold text-custom-blue"
            >REMOVER FILTRO</span>
          </div>

          <div>
            <b-button
                v-if="canInsertPerson && canManageCollaborators"
                class="mr-2 cor_botao"
                variant="outline-primary"
                @click="openModalColaborador"
            >
              <feather-icon icon="UserPlusIcon" />
            </b-button>
            <b-button
                v-if="canExport"
                class="mr-2 cor_botao"
                variant="outline-primary"
                @click="downloadSpreadsheet"
            >
              <feather-icon icon="DownloadIcon" />
            </b-button>
          </div>
        </b-row>
        <b-row class="pt-2">
          <b-col
              class="d-flex flex-wrap p-0"
            >
            <b-col lg="3">
              <b-form-group
                  label="Status"
                  label-for="status-input"
                  label-class="font_size_label"
              >
                <v-select
                    id="status-input"
                    v-model="search.status"
                    variant="custom-blue"
                    class="bg-white"
                    placeholder="Selecione um status"
                    label="label"
                    :options="statusSelect"
                >
                  <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="3">
                <VaccineFilterInput @input="aoAlterarFiltroDeVacina" :search="search" :idCampanha="campaign.idCampaign" :idGrupo="group.idGroup" :idEmpresa="company ? company.idCompany : null"/>
            </b-col>
            <b-col lg="3">
              <b-form-group
                label="Dose"
                label-for="dose-input"
                label-class="font_size_label"
              >
                <v-select
                  id="dose-input"
                  v-model="search.dose"
                  variant="custom"
                  class="bg-white"
                  label="descricao"
                  :options="doseSelect"
                  placeholder="Selecione uma dose"
                  :loading="loadingDoses"
                  :disabled="loadingDoses"
                >
                  <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Categoria"
                  label-for="categoria-input"
                  label-class="font_size_label"
              >
                <v-select
                    id="categoria-input"
                    v-model="search.categoria"
                    variant="custom"
                    class="bg-white"
                    label="descricao"
                    :options="categoriaSelect"
                    placeholder="Selecione uma categoria"
                >
                  <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="Nome"
                  label-for="nome-input"
                  label-class="font_size_label"
              >
                <b-form-input
                    id="nome-input"
                    v-model="search.nome"
                    placeholder="Nome da pessoa"
                />
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="CPF"
                  label-for="cpf-input"
                  label-class="font_size_label"
              >
                <b-form-input
                    id="cpf-input"
                    v-model="search.cpf"
                    v-mask="'###.###.###-##'"
                    placeholder="000.000.000-00"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group
                  label="Endereço"
                  label-for="endereco-input"
                  label-class="font_size_label"
                >
                  <v-select
                    id="endereco-input"
                    v-model="search.endereco"
                    variant="custom"
                    class="bg-white"
                    :options="enderecoSelect"
                    placeholder="Selecione um endereço"
                    :reduce="(option) => option.id_empresa_endereco"
                    append-to-body
                  >
                    <template #option="data">
                      <span>
                        <b>{{ data.descricao || '-' }}</b><br />
                          {{ formatEndereco(data) }}
                      </span>
                    </template>
                    <template #selected-option="data">
                      <span>
                        <b>{{ data.descricao || '-' }}</b><br />
                          {{ formatEndereco(data) }}
                      </span>
                    </template>
                      <span slot="no-options">Nenhuma opção selecionável.</span>
                  </v-select>
                </b-form-group>
              </b-col>
            <b-col lg="2" class="d-flex align-items-end">
              <b-button
                  class="mb-1 col-12"
                  variant="primary-button"
                  @click="filter"
              >
                <feather-icon
                    icon="SearchIcon"
                    class="mr-50"
                />
                <span class="align-middle">Filtrar</span>
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </section>
      <section
          v-if="multiSelect.count && (canInsertMultiple || canExcludeMultiple)"
      >
        <b-row class="d-flex justify-content-center align-items-center">
          <b-col
              lg="6"
              center
          >
            <b-button
                v-if="(multiSelect.case === 'success' && canInsertMultiple && !isSuporte) || (hasMultiplasDosesSelected && canInsertMultiple && !isSuporte)"
                class="m-1 text-uppercase"
                variant="success"
                @click="vaccinateMultiple"
            >
              <span class="align-middle">VACINAR POR LOTE DE VACINAÇÃO</span>
            </b-button>
            <b-button
                v-if="multiSelect.case === 'danger' && canExcludeMultiple && !isSuporte && !isVacinadorPadrao && !hasOnlyFinalizedSelected"
                class="m-1 text-uppercase"
                variant="danger"
                @click="unvacinatedMultiple"
            >
              <span class="align-middle">REMOVER VACINA</span>
            </b-button>
            <b-button
                v-if="multiSelect.case === 'danger' && isSuporte && canCancelFinalizedVaccination && multiSelect.count > 1"
                class="m-1 text-uppercase"
                variant="danger"
                @click="unvacinatedMultipleFinalized"
            >
              <span class="align-middle">CANCELAR SELECIONADOS</span>
            </b-button>
          </b-col>
          <b-col
              lg="6"
              class="align-items-center pb-1"
          >
              <span
                  v-if="multiSelect.case === 'success' && canInsertMultiple && !isSuporte"
                  class="text-uppercase"
              >
              <button
                class="text-custom-blue button-icon"
                @click="openModalConfirm('desmarcar')"
                aria-label="Remover seleção"
              >
                <feather-icon size="28" icon="XIcon" />
              </button>
              {{ multiSelect.count }} selecionados
              <button
                class="text-custom-blue text-link button-icon text-uppercase"
                @click="selectAllNonVaccinated()"
                aria-label="Marcar todos os Não vacinados"
              >
                (Marcar todos os Não vacinados)
              </button>
            </span>
              <span
              v-if="multiSelect.case === 'danger' && isSuporte && canCancelFinalizedVaccination && multiSelect.count > 1"
              class="text-uppercase"
            >
            <button
                class="text-custom-blue button-icon"
                @click="openModalConfirm('desmarcar')"
                aria-label="Remover seleção"
              >
                <feather-icon size="28" icon="XIcon" />
              </button>
              {{ multiSelect.count }} selecionados
              <button
                class="text-custom-blue text-link button-icon text-uppercase"
                @click="selectAllFinalized()"
                aria-label="Marcar todos os Finalizados"
              >
                (Marcar todos os Finalizados)
              </button>
            </span>
            <span
              v-if="multiSelect.case === 'danger' && canExcludeMultiple && !isSuporte && !hasOnlyFinalizedSelected"
              class="text-uppercase"
            >
              <button
                class="text-custom-blue button-icon"
                @click="openModalConfirm('desmarcar')"
                aria-label="Remover seleção"
              >
                <feather-icon size="28" icon="XIcon" />
              </button>
              {{ multiSelect.count }} selecionados
              <button
                class="text-custom-blue text-link button-icon text-uppercase"
                @click="selectAllVaccinated()"
                aria-label="Marcar todos os vacinados"
              >
                (Marcar todos os vacinados)
              </button>
            </span>
          </b-col>
        </b-row>
      </section>
      <section
          v-if="!loadingData"
          class="list-vacinacao"
      >
        <b-table
            id="tableVacinacao"
            ref="tableVacinacao"
            responsive
            :sticky-column="true"
            :busy.sync="filtering"
            :fields="table.fields"
            :items="table.items"
            no-local-sorting
            :no-sort-reset="true"
            @sort-changed="ordenarColuna"
        >
          <template
              v-if="canInsertMultiple || canExcludeMultiple"
              #head(id_pessoa_fisica)
          >
            <b-form-checkbox
                v-model="selectAll"
                :indeterminate="selectAll"
            />
          </template>
          <template
              #cell(id_pessoa_fisica)="row"
          >
            <b-form-checkbox
                v-if="filtroCheckbox(row.item)"
                v-model="row.item.selected"
                @change="verifyIfTwoStatesSelected(row.item)"
            />
          </template>
          <template #cell(nome_empresa)="row">
            <div class="comprimento_maximo_celulas">
              <span class="comprimento_maximo_celulas "
                    :title="row.item.razao_social_empresa.length > 45 ? row.item.razao_social_empresa : null" v-b-tooltip>
                {{ row.item.razao_social_empresa ? row.item.razao_social_empresa : '' }}
              </span>
              <br/>
              <span class="font-weight-bold comprimento_maximo_celulas"
                    :title="row.item.nome_empresa.length > 45 ? row.item.nome_empresa : null" v-b-tooltip>
                {{ row.item.nome_empresa ? row.item.nome_empresa : '' }}
             </span>
            </div>
          </template>
          <template #cell(nome)="row">
              <div>
                <span class="font-weight-bold comprimento_maximo_celulas d-block">
                  {{ row.item.nome }}
                </span>
                <small class="text-muted">{{ row.item.cpf | formataCpfCnpj }}</small>
              </div>
          </template>
          <template #cell(categoria)="row">
              <span class="font-weight-bold"
              >
                {{ row.item.categoria }}
              </span>
          </template>
          <template #cell(endereco)="row">
              <span class="font-weight-bold comprimento_maximo_celulas_endereco"
                  v-b-tooltip.hover="row.item.empresa_endereco ? formatEndereco(row.item.empresa_endereco) : null">
                {{ formatEndereco(row.item.empresa_endereco) || "-" }}
              </span>
            </template>
          <template #cell(dose_aplicada)="row">
              <div 
                v-if="row.item.nome_vacina && row.item.aplicacao.situacao !== situacaoAplicacaoEnum.ESTORNADA"
                v-b-tooltip.hover
                :title="formatDescricaoVacinaDose(row.item)"
              >
                <span class="font-weight-bold comprimento_maximo_celulas d-block">
                  {{ row.item.nome_vacina }}
                </span>
                <small class="text-muted">{{ row.item.descricao_dose }}</small>
              </div>
              <span v-else>-</span>
            </template>
          <template #cell(status)="row">
             <b-form-checkbox
              :class="['custom-switch-visual', getSituacaoClass(row.item)]"
              checked="true"
              name="check-button"
              switch
              disabled
              v-b-tooltip="showTooltip(row.item)"
              :title="showTooltip(row.item) ? formatDocumentCompany(row.item.aplicacao) : null"
            >
              {{ getSituacaoLabel(row.item) }}
            </b-form-checkbox>
            </template>
            <template #cell(actions)="row">
               <div
                  v-b-tooltip.hover
                  :title="!canInsert ? 'O usuário logado não possui permissão para vacinar' : 'Efetuar aplicação'"
                  class="button-wrapper"
                >
                  <button v-if="podeVacinar(row.item)"
                    id="vaccine"
                    class="button-icon text-custom-blue mr-1 action-button"
                    :class="{ disabled: !canInsert }"
                    :disabled="!canInsert"
                    @click.prevent="openModalVacinacao(row.item)"
                    aria-label="Efetuar aplicação"
                  >
                    <img
                      :src="SyringeIcon"
                      alt="Vacina"
                      class="vaccine-icon"
                    />
                  </button>
                </div>
                <div
                  v-b-tooltip.hover
                  :title="deveDesabilitarBotaoCancelarEstornarVacinacao(row.item) ? 'O usuário logado não possui permissão para cancelar aplicação' : 'Cancelar aplicação'"
                  class="button-wrapper"
                >
                  <button v-if="row.item.vacinado" id="cancel"
                    class="button-icon text-custom-blue mr-1 action-button"
                    :class="{ disabled: deveDesabilitarBotaoCancelarEstornarVacinacao(row.item) }"
                    :disabled="deveDesabilitarBotaoCancelarEstornarVacinacao(row.item)"
                    @click.prevent="openModalCancelarEstornarVacinacao(row.item)"
                    aria-label="Cancelar aplicação">
                    <feather-icon icon="XIcon" size="18" />
                  </button>
                </div>
                <div
                  v-b-tooltip.hover
                  title="Visualizar informações de cancelamento"
                  class="button-wrapper"
                >
                  <button v-if="estornoStatus[row.item.id_pessoa_fisica]" id="cancelado-show"
                    class="button-icon text-custom-blue"
                    @click.prevent="openModalInformacoesCancelamento(row.item)"
                    aria-label="Visualizar informações de cancelamento">
                    <feather-icon icon="EyeIcon" size="18" />
                  </button>
              </div>
            </template>
        </b-table>
        <div class="pb-2 px-1">
            <span
                v-if="without"
                class="ml-1"
            >Nenhum colaborador encontrado</span>
          <b-col
              sm="12"
              class="mt-2"
              v-if="!without"
          >
            <CustomPagination
                :paginacao="paginationData"
                @page-cliked="updateCurrentPage"
            />
          </b-col>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  VBTooltip,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue'
import InfoSideCard from '@/views/components/custom/cards/InfoSideCard.vue'
import AddNovoColaborador from '@/views/components/custom/modals/vacinacao/Add-novo-colaborador.vue'
import AddNovaVacinacao from '@/views/components/custom/modals/vacinacao/Add-nova-vacinacao.vue'
import ConfirmModalVacinacao from '@/views/components/custom/modals/vacinacao/ConfirmModalVacinacao.vue'
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue'
import moment from 'moment';
import {actions, subjects} from "@/libs/acl/rules";
import SyringeIcon from '@/assets/images/icons/syringe.svg'
import {successMessage} from "@/libs/sweetalerts";
import { getInfoUserDepartamento } from "@core/utils/store/getStore";
import chavePerfil from '@/enum/chavePerfil'
import { situacaoAplicacaoEnum, situacaoAplicacaoLabelEnum } from '@/enum/situacaoAplicacao'
import ModalCancelVacinacao from '@/views/components/custom/modals/vacinacao/ModalCancelVacinacao.vue'
import ModalInformacoesCancelamento from '@/views/components/custom/modals/vacinacao/ModalInformacoesCancelamento.vue'
import ModalSelectActionMultiplasDoses from '@/views/components/custom/modals/vacinacao/ModalSelectActionMultiplasDoses.vue'
import ModalCancelarAplicacoesMultiplasDoses from '@/views/components/custom/modals/vacinacao/ModalCancelarAplicacoesMultiplasDoses.vue'
import VaccineFilterInput from '../../components/VaccineFilterInput.vue'
import vacinacaoMixin from '../../mixins/vacinacaoMixin'

export default {
  title: 'Lista de registros de vacinação',
  mixins: [vacinacaoMixin],

  components: {
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    CustomPagination,
    BFormCheckbox,
    InfoSideCard,
    AddNovoColaborador,
    AddNovaVacinacao,
    ConfirmModalVacinacao,
    SucessoModal,
    ModalCancelVacinacao,
    ModalInformacoesCancelamento,
    ModalSelectActionMultiplasDoses,
    ModalCancelarAplicacoesMultiplasDoses,
    SyringeIcon,
    VaccineFilterInput
  },

  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    }
  },

  data() {
    return {
      moment,
      doses: [
        {
          icon: 'ClipboardIcon',
          color: 'light-primary',
          title: 0,
          subtitle: 'Doses Contratadas',
        },
        {
          icon: 'CheckIcon',
          color: 'light-success',
          title: 0,
          subtitle: 'Doses Aplicadas',
        },
        {
          icon: 'LoaderIcon',
          color: 'light-warning',
          title: 0,
          subtitle: 'Doses Pendentes',
        },
      ],
      table: {
        fields: [
          {
            key: 'id_pessoa_fisica',
            label: '',
            sortable: false,
            class: 'mxw-15 pr-0',
          },
          {
            key: 'nome_empresa', label: 'EMPRESA', sortable: true, class: 'mw-180',
          },
          {
            key: 'nome', label: 'NOME', sortable: true, class: 'mw-180',
          },
          {
            key: 'categoria',
            label: 'CATEGORIA',
            sortable: false,
            class: 'text-center mw-100',
          },
          {
            key: 'endereco',
            label: 'ENDEREÇO',
            sortable: false,
            class: 'mw-100',
          },
          {
            key: 'dose_aplicada', label: 'DOSE APLICADA', sortable: false, class: 'mw-200',
          },
          {
            key: 'status', label: 'STATUS', sortable: false, class: 'text-center mw-50',
          },
          {
            key: "actions", label: "AÇÕES", sortable: false, class: 'mw-30',
          },
        ],
        items: [],
        optionsSize: [10, 25, 50, 100],
        columnOrder: 'nome',
        order: 'asc',
      },
      paginationData: {
        currentPage: 1,
        totalLines: 0,
        fromLine: 0,
        toLine: 0,
        defaultSize: 10,
      },
      loadingData: true,
      filtering: false,
      canInsertMultiple: false,
      canExcludeMultiple: false,
      canExclude: false,
      showFilter: false,
      canInsertPerson: false,
      canExport: false,
      canCancelFinalizedVaccination: false,
      isVacinadorPadrao: false,
      isSuporte: false,
      categoriaSelect: [],
      timeID: null,
      statusSelect: [
        {
          label: 'Finalizado',
          value: 'Finalizado',
        },
        {
          label: 'Vacinado',
          value: 'Vacinado',
        },
        {
          label: 'Cancelado',
          value: 'Cancelado',
        },
        {
          label: 'Não vacinado',
          value: false,
        },
      ],
      search: {
        status: '',
        categoria: '',
        nome: '',
        dose: '',
        cpf: '',
        endereco: '',
        vacina: null
      },
      without: false,
      searchTerm: '',
      modalVacinacao: {
        showModal: false,
        colaborador: null,
        doses: null
      },
      vacinadorSelect: [],
      doseSelect: [],
      loteSelect: [],
      enderecoSelect: [],
      companyNewVaccination: null,
      unitNewVaccination: null,
      addressesNewVaccination: [],
      modalSucesso: {
        showModal: false,
        typeModal: 'success',
        caseModal: 'criacao',
      },
      modalColaborador: {
        showModal: false,
      },
      groupCompanies: [],
      modalConfirm: {
        showModal: false,
        typeModal: 'remover',
        confirmed: this.closeModalConfirm,
        canceled: this.closeModalConfirm,
        disableCancel: false,
        tooltipCancel: '',
      },
      pessoaRemover: 0,
      descricaoDose: '',
      multiSelect: {
        count: 0,
        case: 'danger',
      },
      modalSucessoCancelamento: {
        showModal: false,
        typeModal: 'success',
        caseModal: 'cancelamento',
      },
      modalCancelVacinacao: {
        showModal: false,
        colaborador: null,
        canceled: this.closeModalCancelarVacinacao,
      },
      modalInformacoesCancelamento: {
        showModal: false,
        colaborador: null,
        canceled: this.closeModalInformacoesCancelamento,
      },
      modalCancelarAplicacoesMultiplasDoses: {
        showModal: false,
        canceled: this.handleCloseModalCancelarAplicacoesMultiplasDoses,
      },
      selectAll: false,
      unselectItemColab: null,
      showCompanySelectNewCollaborator: true,
      idCompanyNewCollaborator: null,
      canManageCollaborators: false,
      showCollaboratorsAnotherGroup: false,
      departamentIdNewVaccination: null,
      departamentUserLogged: null,
      estornoStatus: {},
      dadosEstorno: {},
      canInsert: false,
      colaboradorSelecionadoTemporario: null,
      aplicacoesColaborador: [],
      vacinasCampanha: [],
      vacinaSelecionada: null,
      SyringeIcon,
      loadingDoses: false,
    }
  },

  computed: {
    situacaoAplicacaoEnum() {
      return situacaoAplicacaoEnum
    },
    group() {
      return this.params.grupo;
    },
    campaign() {
      return this.params.campanha;
    },
    unit() {
      return this.params.unidade;
    },
    company() {
      return this.params.empresa;
    },
    hasMultiplasDosesSelected() {
      const colaboradoresMultiplasDoses = this.table.items.filter(
        item => item.selected && 
               item.id_dose !== 1 && 
               item.id_dose !== null && 
               (item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA || item.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA)
      )
      return colaboradoresMultiplasDoses.length > 1
    },
    hasOnlyFinalizedSelected() {
      const selecionados = this.table.items.filter(i => i.selected);
      return selecionados.length > 0 && selecionados.every(i => i.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA);
    },
  },

  watch: {
    selectAll(val) {
      this.verifyIfTwoStatesSelected()

      if (!val) {
        this.unselectAll()
        return
      }

      if(this.isSuporte) {
        this.selectAllFinalized()
      }else{
        this.openModalConfirm('marcar')

      if (this.company) {
        this.modalConfirm.disableCancel = false;
        this.modalConfirm.tooltipCancel = '';
      } else {
        this.modalConfirm.disableCancel = true;
        this.modalConfirm.tooltipCancel = 'Não é possível vacinar em lote em um grupo de empresas.';
      }

      this.modalConfirm.confirmed = this.selectAllVaccinated
      this.modalConfirm.canceled = this.selectAllNonVaccinated
      }

    },
  },

  async mounted() {
    try {
      this.loadingData = true;
      this.departamentUserLogged = getInfoUserDepartamento('id_departamento');
      this.canInsert = this.verifyPermissions(actions.INSERIR)

      const perfil = this.$store.state.sessions.userData.perfis[0].chave;
      this.isVacinadorPadrao = perfil === chavePerfil.VACINADOR_PADRAO
      this.isSuporte = perfil === chavePerfil.SUPORTE

      await Promise.all([
        this.loadGroupQuantities(),
        this.loadGroupCollaborators(),
        this.loadCategories(),
        this.loadVaccinators(),
        this.loadAddresses(),
        this.loadLotes(this.company?.idCompany),
        this.company ? this.loadCollaboratorsPermissionFromCompany() :  null
      ]);

      this.initializePermissions();

      const isVaccinator = perfil === chavePerfil.VACINADOR_PADRAO || perfil === chavePerfil.VACINADOR_ADMIN;

      if (this.$can(actions.INSERIR, subjects.EMPRESA_COLABORADOR) && !isVaccinator)  {
        await this.loadGroupCompanies(this.departamentUserLogged)
      }

      if (!this.company && this.groupCompanies.length > 0) {
        this.canManageCollaborators = true;
      }

      this.departamentIdNewVaccination = this.unit.idDepartment;
      this.showCompanySelectNewCollaborator = this.company === null;
      this.idCompanyNewCollaborator = this.company?.idCompany ?? null;
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    initializePermissions(){
      this.canExclude = this.verifyPermissions(actions.EXCLUIR)
      this.canExcludeMultiple = this.verifyPermissions(actions.EXCLUIR_MULTIPLO)
      this.canInsert = this.verifyPermissions(actions.INSERIR)
      this.canInsertPerson = this.$can(
          actions.INSERIR,
          subjects.EMPRESA_COLABORADOR,
      )
      this.canInsertMultiple = this.verifyPermissions(actions.INSERIR_MULTIPLO) && this.company
      this.canExport = this.verifyPermissions(actions.EXPORTAR)

      if(this.isSuporte) {
        this.$http.get(this.$api.usuarioId(this.$store.state.sessions.userData.id)).then((response) => {
          if(response.data.permite_estornar_vacinacao){
            this.canCancelFinalizedVaccination = true
          }
        })
      }else{
        this.$http.get(this.$api.usuarioAdminId(this.$store.state.sessions.userData.id)).then((response) => {
          if(response.data.permite_estornar_vacinacao){
            this.canCancelFinalizedVaccination = true
          }
        })
      }
    },
    async selectAllVaccinated() {
      this.unselectAllWithSameStatus(false)

      const filtro = item =>
        item.vacinado && !item.aplicacao.outra_empresa_aplicadora && item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA

      await this.selectMaiorGrupoConsistente(filtro, this.vacinaSelecionada)
    },
    selectAllNonVaccinated() {
      this.unselectAllWithSameStatus(true)
      const toSelect = this.table.items.filter(item => !item.vacinado || item.aplicacao.situacao === situacaoAplicacaoEnum.ESTORNADA
        && item.aplicacao.situacao != situacaoAplicacaoEnum.APLICADA
        && item.aplicacao.situacao != situacaoAplicacaoEnum.FINALIZADA)

      toSelect.map(item => {
        item.selected = true
      })

      this.$refs.tableVacinacao.refresh()
      this.verifyIfTwoStatesSelected()
      this.closeModalConfirm()
    },
    async selectAllFinalized() {
      await this.selectMaiorGrupoConsistente(
        item => item.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA
      )
    },
    unselectAllWithSameStatus(status) {
      const toSelect = this.table.items.filter(item => item.vacinado == status)

      toSelect.map(item => {
        item.selected = false
      })
      this.$refs.tableVacinacao.refresh()
    },
    verifyPermissions(action) {
      const permission = this.$can(
          actions[action],
          subjects.REGISTRO_VACINACAO_SESI,
      )

      return [permission].includes(true)
    },
    async loadGroupQuantities() {
      const params = {
        idCampanha: this.campaign.idCampaign,
        idGrupo: this.group.idGroup,
        idUnidade: this.unit.idUnit
      };

      if (this.company) {
        params['idEmpresa'] = this.company.idCompany;
      }

      if (this.search.vacina) {
        params['idVacina'] = this.search.vacina.id_vacina;
      }

      await this.$http.get(this.$api.adesaoNacionalQuantitativos(), {params: params}).then(({data}) => {
        this.doses[0].title = data.quantidadeTotalAderida;
        this.doses[1].title = data.quantidadeAplicada;
        this.doses[2].title = data.quantidadeNaoAplicada;
      })
    },
    async loadAddresses() {
      if (!this.company) {
        const empresas = await this.$http.get(this.$api.getAndPutAndDeleteGrupo(this.group.idGroup)).then(res => res.data);

        const enderecosPromises = empresas.empresa_operador.map(empresa =>
          this.$http.get(this.$api.getShowAndEditEmpresa(empresa.id_empresa))
        );

        const enderecosRespostas = await Promise.all(enderecosPromises);
        const todosEnderecos = enderecosRespostas.flatMap(res => res.data.enderecos);

        this.enderecoSelect = todosEnderecos.map(endereco => ({
          ...endereco,
          label: this.formatEndereco(endereco),
        }));
      } else {
        await this.$http.get(this.$api.getShowAndEditEmpresa(this.company.idCompany)).then(({ data }) => {
          this.enderecoSelect = data.enderecos.map((endereco) => {
            return {
              ...endereco,
              label: this.formatEndereco(endereco),
            };
          });
        });
      }
    },
    async loadGroupCollaborators() {
      this.multiSelect.count = 0
      this.estornoStatus = {}
      this.dadosEstorno = {}

      const params = {
        paginacao: true,
        tamanho: this.paginationData.defaultSize,
        pagina: this.paginationData.currentPage,
        colunaOrdenar: this.table.columnOrder,
        vacinado: this.search.status ? this.search.status.value : '',
        ordem: this.table.order,
        ordem_vacinados: 'desc',
        id_campanha: this.campaign.idCampaign,
        id_vacina: this.search.vacina ? this.search.vacina.id_vacina : '',
        id_dose: this.search.dose ? this.search.dose.id_dose : '',
        id_categoria: this.search.categoria
            ? this.search.categoria.id_categoria
            : '',
        cpf: this.search.cpf,
        id_unidade: this.unit.idUnit,
        ano: moment().format('YYYY'),
        ativo: true,
        nome: this.search.nome,
        id_grupo: this.group.idGroup,
        vacinado_outro_grupo: this.showCollaboratorsAnotherGroup,
        id_empresa_endereco: this.search.endereco
            ? this.search.endereco
            : null
      };

      if (this.company) {
        params['id_empresa'] = this.company.idCompany;
      }

      await this.$http.get(this.$api.colaboradorVacinacao(), {params: params}).then(({data}) => {
        this.table.items = data.data;
        
        if (data.data.length === 0) {
          this.without = true
        }else{
          this.without = false
        }

        this.buscaEstornosEmLote();
        this.loadDosesSelect();

        this.startPagination(data);
        this.filtering = false;
      })
    },
    async loadGroupCompanies(idDepartment) {
      await this.$http.get(this.$api.getAndPutAndDeleteGrupo(this.group.idGroup)).then(({data}) => {
        const companies = data.empresa_operador.filter(empresaOperador => {
          return empresaOperador.grupo_operadores.some(go => {
            return go?.id_operador === idDepartment
          });
        });

        this.groupCompanies = companies.map(company => ({
          id_empresa: company.id_empresa,
          nome_empresa: company.nome_empresa,
          documento_formatado: company.documento_formatado,
          razao_social: company.razao_social,
          documento: company.documento,
        }))
      })
    },
    async loadCollaboratorsPermissionFromCompany() {
      await this.$http.get(this.$api.getShowAndEditEmpresa(this.company.idCompany)).then(({data}) => {
        this.canManageCollaborators = data['pode_gerenciar_colaboradores'];
      })
    },
    async vaccinateMultiple() {
      const selected = this.table.items.filter(item => item.selected);

      const dosesPromises = selected.map(colaborador =>
        this.loadDosesColaborador(colaborador)
      );
      
      try {
        const dosesResults = await Promise.all(dosesPromises);
        
        if (!this.validarMesmasDosesAplicadas(selected, dosesResults)) {
          this.openModalConfirm('dosesDiferentes')
          return
        }
        
        const todasDoses = dosesResults.flat();
        
        await this.loadLotes(this.company.idCompany);
        await this.loadAddressesNewVaccination(this.company.idCompany);

        this.companyNewVaccination = {id_empresa: this.company.idCompany};
        this.unitNewVaccination = {id_unidade: this.unit.idUnit};

        this.modalVacinacao.colaborador = selected;
        this.modalVacinacao.doses = todasDoses;
        this.openModalVacinacao();
      } catch (error) {
        console.error('Erro ao carregar doses dos colaboradores:', error);

        await this.loadLotes(this.company.idCompany);
        await this.loadAddressesNewVaccination(this.company.idCompany);

        this.companyNewVaccination = {id_empresa: this.company.idCompany};
        this.unitNewVaccination = {id_unidade: this.unit.idUnit};

        this.modalVacinacao.colaborador = selected;
        this.modalVacinacao.doses = [];
        this.openModalVacinacao();
      }
    },
    async unvacinatedMultiple() {
      const selected = this.table.items.filter(item => item.selected && item.aplicacao.situacao != situacaoAplicacaoEnum.FINALIZADA)

      const dosesPromises = selected.map(colaborador =>
        this.loadDosesColaborador(colaborador)
      );

      try {
        const dosesResults = await Promise.all(dosesPromises);

        if (!this.validarMesmasDosesAplicadas(selected, dosesResults)) {
          this.openModalConfirm('dosesDiferentes')
          return
        }

        const descricaoDose = this.formatDescricaoVacinaDose(selected[0]);

        this.modalVacinacao.colaborador = selected
        this.pessoaRemover = selected.length || 1
        this.descricaoDose = descricaoDose
        this.openModalConfirm('removerMultiplo')

      } catch (error) {
        console.error('Erro ao carregar doses dos colaboradores:', error);
      }
    },
    unselectAll() {
      this.multiSelect.count = 0
      this.selectAll = false
      this.table.items.map(item => {
        item.selected = false
      })
      this.closeModalConfirm()
    },
    cancelarVacinacao(data) {
      let pessoas = [];

      if (data) {
          const { colaborador } = this.modalCancelVacinacao;
          this.loadingData = true;
          this.unselectAll();
          this.pessoaRemover = colaborador.length || 1;

          pessoas = colaborador.map(element => ({
              id_aplicacao: element.id_aplicacao || element.aplicacao.id_aplicacao,
              motivo_cancelamento: data.justificativa,
          }))
      } else {
          const { colaborador } = this.modalVacinacao;
          this.loadingData = true;
          this.unselectAll();
          this.pessoaRemover = colaborador.length || 1;

          pessoas = colaborador.map(element => ({
              id_aplicacao: element.id_aplicacao || element.aplicacao.id_aplicacao,
              motivo_cancelamento: 'Cancelamento realizado via sistema',
          }));
      }

      this.$http
          .post(this.$api.vacinacaoCancelar(), { pessoas })
          .then(async response => {
            if (response.status === 201) {
              successMessage('Cancelamento realizado com sucesso!')

              this.table.items = []

              this.paginationData = {
                currentPage: 1,
                totalLines: 0,
                fromLine: 0,
                toLine: 0,
                defaultSize: 10,
              }

              this.closeModalCancelarVacinacao();
              this.handleCloseModalCancelarAplicacoesMultiplasDoses();

              await this.loadGroupCollaborators();
              await this.loadGroupQuantities();

              this.loadingData = false;
            }
          })
          .catch(err => {
            this.modalError.caseModal = 'naoInativo'
            this.openModalError()
          })
    },
    openModalError() {
      this.modalError.showModal = true
    },
    startPagination(data) {
      this.paginationData.currentPage = data.meta.current_page
      this.paginationData.totalLines = data.meta.total
      this.paginationData.fromLine = data.meta.from
      this.paginationData.toLine = data.meta.to
    },
    ordenarColuna(sort) {
      this.table.columnOrder = sort.sortBy;
      this.table.order = sort.sortDesc ? 'desc' : 'asc';

      this.filtering = true;

      this.loadGroupCollaborators();
    },
    unselectItem() {
      this.table.items.map(item => {
        if (item.id_pessoa_fisica == this.unselectItemColab.id_pessoa_fisica) {
          item.selected = false
        }
      })
      this.$refs.tableVacinacao.refresh()
      this.unselectItemColab = null
      this.closeModalConfirm()
    },
    verifyIfTwoStatesSelected(i = null) {
      const selected = this.table.items.filter(
          item => item.selected
              && item.vacinado
              && item.aplicacao.situacao != situacaoAplicacaoEnum.ESTORNADA,
      )
      const notSelected = this.table.items.filter(
          item => item.selected && (!item.vacinado || item.aplicacao.situacao == situacaoAplicacaoEnum.ESTORNADA),
      )

      if (selected.length && notSelected.length) {
        this.openModalConfirm('selecionar')

        this.modalConfirm.confirmed = this.unselectItem
        this.unselectItemColab = i
        return
      }

      if (selected.length > 1) {
        this.multiSelect.count = selected.length
        this.multiSelect.case = 'danger'
      }

      if (notSelected.length > 1) {
        this.multiSelect.count = notSelected.length
        this.multiSelect.case = 'success'
      }

      if (selected.length <= 1 && notSelected.length <= 1) {
        this.multiSelect.count = 0
      }
    },
    foiVacinadoPorOutraEmpresa(item) {
      return item.aplicacao.outra_empresa_aplicadora
    },
    formatDocumentCompany(item) {
      const titleDocument = `Vacinado na empresa ${item.nome_fantasia_empresa_aplicadora} de `

      if (item.cpf_empresa_aplicadora) {
        return `${titleDocument}CPF ${this.$options.filters.formataCpfCnpj(item.cpf_empresa_aplicadora)}`
      }
      return `${titleDocument}CNPJ ${this.$options.filters.formataCpfCnpj(item.cnpj_empresa_aplicadora)}`
    },
    getSituacaoLabel(item) {
      return situacaoAplicacaoLabelEnum[item.aplicacao.situacao] || 'Não vacinado';
    },
    getSituacaoClass(item) {
      const label = this.getSituacaoLabel(item);
      const isOutraEmpresa = this.foiVacinadoPorOutraEmpresa(item);
      const isFinalizadoOuVacinado = label === 'Finalizado' || label === 'Vacinado';

      return {
        'custom-switch-success': isFinalizadoOuVacinado && !isOutraEmpresa,
        'custom-switch-primary': isFinalizadoOuVacinado && isOutraEmpresa,
        'custom-switch-danger': label === 'Cancelado',
        'custom-switch-secondary': label === 'Não vacinado',
      };
    },
    showTooltip(item) {
      return this.foiVacinadoPorOutraEmpresa(item) &&
        (item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA || item.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA);
    },
    deveDesabilitarBotaoCancelarEstornarVacinacao(item){
      const isMultiplaDose = item.id_dose !== 1 && item.id_dose !== null;
      const campanhaTemMultiplasVacinas = this.vacinasCampanha && this.vacinasCampanha.length > 1;

      if (isMultiplaDose || campanhaTemMultiplasVacinas) {
        return false;
      }

      return (item.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA && !this.canCancelFinalizedVaccination) ||
        (item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA && !this.canExclude) ||
        (item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA && this.isSuporte) ||
        (item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA && this.isVacinadorPadrao);
    },
    filtroCheckbox(item) {
      if (this.isSuporte && this.canCancelFinalizedVaccination) {
        return item.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA
      }else if(this.isSuporte && !this.canCancelFinalizedVaccination) {
        return false
      }
      return (
        ((this.company && item.aplicacao.situacao !== situacaoAplicacaoEnum.FINALIZADA) ||
        (!this.company && item.aplicacao.situacao === situacaoAplicacaoEnum.APLICADA)) &&
        !item.aplicacao.outra_empresa_aplicadora
      );
    },
    async loadDosesColaborador(colaborador) {
      return this.$http.get(this.$api.listarDosesColaborador(), {
        params: {
          id_pessoa_fisica: colaborador.id_pessoa_fisica,
          id_unidade: this.unit.idUnit,
          id_campanha: this.campaign.idCampaign,
          ano: colaborador.ano,
        }
      }).then(response => {
        this.aplicacoesColaborador = response.data;
        return response.data;
      }).catch(error => {
        console.error('Erro ao carregar doses do colaborador:', error);
        return [];
      });
    },
    async openModalCancelarAplicacoesMultiplasDoses(colaborador) {
      const doses = await this.loadDosesColaborador(colaborador);
      this.modalCancelarAplicacoesMultiplasDoses.colaborador = doses;
      this.modalCancelarAplicacoesMultiplasDoses.showModal = true;
    },
    handleCloseModalCancelarAplicacoesMultiplasDoses() {
      this.colaboradorSelecionadoTemporario = null;
      this.modalCancelVacinacao.colaborador = null;
      this.modalCancelarAplicacoesMultiplasDoses.showModal = false;
      this.aplicacoesColaborador = null;
    },
    async loadAddressesNewVaccination(companyId) {
      const addressesWithAdhesion = await this.getAddressesWithAdhesion(
          companyId,
          this.campaign.idCampaign,
          this.group.idGroup
      );

      await this.$http.get(this.$api.getShowAndEditEmpresa(companyId)).then(({data}) => {
        this.addressesNewVaccination = data.enderecos.filter(
            address =>
                addressesWithAdhesion.includes(address.id_empresa_endereco)
        );
      });
    },
    async getAddressesWithAdhesion(companyId, campaignId, groupId) {
      const params = {
        id_empresa: companyId,
        id_campanha: campaignId,
        id_grupo: groupId,
      }

      return await this.$http.get(this.$api.empresasComAdesao(), {params: params}).then(({data}) => {
        return data?.[0]?.enderecos_com_adesao ?? [];
      });
    },
    updateCurrentPage(page) {
      this.paginationData.currentPage = page
      this.filtering = true
      this.loadGroupCollaborators()
    },
    async openModalVacinacao(colaborador) {
      if(colaborador){
        this.modalVacinacao.colaborador = [colaborador];

        await this.loadAddressesNewVaccination(colaborador.id_empresa);
        await this.loadLotes(this.company?.idCompany);

        this.companyNewVaccination = { id_empresa: colaborador.id_empresa };
        this.unitNewVaccination = { id_unidade: this.unit.idUnit };

        const doses = await this.loadDosesColaborador(colaborador);

        this.modalVacinacao.doses = doses;
      }
      this.modalVacinacao.showModal = true
    },
    openModalColaborador() {
      this.modalColaborador.showModal = true
    },
    async openModalConfirm(type) {
      if(type === 'marcar'){
        await this.loadLotes();
      }
      this.modalConfirm.showModal = true
      this.modalConfirm.typeModal = type
      if (type == 'desmarcar' || type == 'remover' || type == 'removerMultiplo' || type == 'dosesDiferentes') {
        this.modalConfirm.confirmed = this.unselectAll
        this.modalConfirm.canceled = this.closeModalConfirm
      }
    },
    downloadSpreadsheet() {
      const params = {
        paginacao: false,
        vacinado: this.search.status ? this.search.status.value : '',
        ordem: this.table.order,
        id_campanha: this.campaign.idCampaign,
        id_vacina: this.search.vacina ? this.search.vacina.id_vacina : '',
        id_dose: this.search.dose ? this.search.dose.id_dose : '',
        id_categoria: this.search.categoria
            ? this.search.categoria.id_categoria
            : '',
        cpf: this.search.cpf,
        ano: moment().format('YYYY'),
        ativo: true,
        id_unidade: this.unit.idUnit,
        id_grupo: this.group.idGroup,
      };

      if (this.company) {
        params['id_empresa'] = this.company.idCompany;
      }

      this.$http
          .get(this.$api.colaboradorVacinacao(), {
            params: params,
          })
          .then(({ data }) => {
            const content = data.data.map(item => {
              let vacinacaoStatus = 'Não vacinado';
                if (item.aplicacao.situacao === situacaoAplicacaoEnum.ESTORNADA) {
                  vacinacaoStatus = 'Cancelado';
                } else if (item.vacinado) {
                  vacinacaoStatus = 'Vacinado';
                }

                return {
                  nome: item.nome,
                  cpf: item.cpf,
                  empresa: item.nome_empresa,
                  'data de nascimento': moment(item.data_nascimento).format('DD/MM/YYYY'),
                  categoria: item.categoria,
                  endereco: this.formatEndereco(item.empresa_endereco) || '-',
                  vacinado: vacinacaoStatus,
                }
            })

            this.$helpers.downloadArchiveXlsx(content, 'planilha_vacinacao.xlsx')
          })
    },
    closeFilter() {
      this.showFilter = false;

      this.clearSearch();

      this.filtering = true;
      this.paginationData.currentPage = 1;

      this.loadGroupCollaborators()
      this.loadGroupQuantities()
    },
    clearSearch() {
      this.search.nome = ''
      this.search.status = ''
      this.search.categoria = ''
      this.search.cpf = ''
      this.search.dose = ''
      this.search.endereco = ''
      this.search.vacina = null
    },
    async loadCategories() {
      await this.$http.get(this.$api.getEmpresaCategoria()).then(({data}) => {
        this.categoriaSelect = data;
      })
    },
    async loadLotes(companyId = null) {
      const parameters = {
        id_unidade: this.unit.idUnit,
        id_campanha: this.campaign.idCampaign,
        id_departamento: this.unit.idDepartment,
        ativo: false,
        id_grupo: this.group.idGroup
      }

      if (companyId) {
        parameters['id_empresa'] = companyId;
      }

      const lotes = await this.$http.get(this.$api.lote(), {
        params: parameters,
      });

      const lotesFiltered = lotes.data
          .filter(lote => lote.saldo > 0)
          .filter(lote => lote.ativo_unidade === true)

      this.loteSelect = lotesFiltered.sort((a, b) => a.numero_lote.localeCompare(b.numero_lote))

      const vacinasMap = new Map();
      lotes.data.forEach(lote => {
        if (!vacinasMap.has(lote.id_vacina)) {
          vacinasMap.set(lote.id_vacina, {
            id_vacina: lote.id_vacina,
            nome_tecnico_vacina: lote.nome_tecnico_vacina,
          });
        }
      });

      this.vacinasCampanha = Array.from(vacinasMap.values());
    },
    filter() {
      if (this.searchTerm.length >= 2 || this.searchTerm.length == 0) {
        this.without = false

        clearTimeout(this.timeID)
        this.timeID = setTimeout(() => {
          this.paginationData.currentPage = 1
          this.filtering = true
          this.loadGroupCollaborators()
          this.loadGroupQuantities()
        }, 500)
      }
    },
    closeModalConfirm() {
      this.closeModalVacinacaoCancel()

      this.modalConfirm.tooltipCancel = '';
      this.modalConfirm.disableCancel = false;
      this.modalConfirm.showModal = false
      this.pessoaRemover = 0
      this.descricaoDose = ''
    },
    async unvacinatedMultipleFinalized() {
      const selected = this.table.items.filter(item => item.selected)

      const dosesPromises = selected.map(colaborador =>
        this.loadDosesColaborador(colaborador)
      );

      try {
        const dosesResults = await Promise.all(dosesPromises);

        if (!this.validarMesmasDosesAplicadas(selected, dosesResults)) {
          this.openModalConfirm('dosesDiferentes')
          return
        }

        this.modalCancelVacinacao.colaborador = selected
        this.pessoaRemover = selected.length || 1

        this.openModalEstornarVacinacaoEmMassa(selected);

      } catch (error) {
        console.error('Erro ao carregar doses dos colaboradores:', error);
      }
    },
    async loadVaccinators() {
      const params = {
        unidadesId: [this.unit.idUnit],
        existsPessoaFisicaDocumento: 1,
        departamentoId: this.unit.idDepartment,
        grupoId: this.group.idGroup,
      }

      if(!this.isSuporte) {
        await this.$http.get(this.$api.vacinadores(), {params}).then(({data}) => {
          this.vacinadorSelect = data;
        });
      }
    },
    closeModalVacinacaoCancel() {
      this.modalVacinacao.colaborador = ''
      this.modalVacinacao.doses = [];
      this.modalVacinacao.showModal = false
    },
    handleCancelarMultiplasDoses(colaborador){
      this.modalVacinacao.colaborador = colaborador.colaborador
      this.descricaoDose = this.formatDescricaoVacinaDose(colaborador.colaborador[0]);
      this.openModalConfirm("remover");
    },
    handleEstornarMultiplasDoses(colaborador){
      this.modalCancelVacinacao.colaborador = colaborador.colaborador;
      this.modalCancelVacinacao.showModal = true
    },
    openModalCancelarEstornarVacinacao(colaborador){
      const isMultiplaDose = colaborador.id_dose !== 1 && colaborador.id_dose !== null;
      const isFinalizada = colaborador.aplicacao.situacao === situacaoAplicacaoEnum.FINALIZADA;
      const campanhaTemMultiplasVacinas = this.vacinasCampanha && this.vacinasCampanha.length > 1;

      if (isMultiplaDose || campanhaTemMultiplasVacinas) {
        this.openModalCancelarAplicacoesMultiplasDoses(colaborador);
        return;
      }

      if(isFinalizada){
        this.modalCancelVacinacao.colaborador = [colaborador];
        this.modalCancelVacinacao.showModal = true
      } else {
        this.modalVacinacao.colaborador = [colaborador];
        this.descricaoDose = this.formatDescricaoVacinaDose(colaborador);
        this.openModalConfirm('remover');
      }

    },
    openModalEstornarVacinacaoEmMassa(colaboradores) {
      this.modalCancelVacinacao.colaborador = colaboradores;
      this.modalCancelVacinacao.showModal = true;
    },
    closeModalCancelarVacinacao() {
      this.modalCancelVacinacao.showModal = false;
      this.modalCancelVacinacao.colaborador = '';
      this.colaboradorSelecionadoTemporario = null;
      this.pessoaRemover = 0;
    },
    openModalInformacoesCancelamento(colaborador){
        this.modalInformacoesCancelamento.showModal = true
        this.modalInformacoesCancelamento.colaborador = this.dadosEstorno[colaborador.id_pessoa_fisica]
    },
    closeModalInformacoesCancelamento(){
      this.modalInformacoesCancelamento.showModal = false
    },
    openModalSucesso() {
      this.closeModalColaborador();
      this.modalVacinacao.showModal = false
      
      const isMassiveVaccination = this.modalVacinacao.colaborador && 
                                  Array.isArray(this.modalVacinacao.colaborador) && 
                                  this.modalVacinacao.colaborador.length > 1;
      
      this.modalSucesso.caseModal = isMassiveVaccination ? 'criacao-em-massa' : 'criacao';
      
      this.modalSucesso.showModal = true
    },
    closeModalColaborador() {
      this.modalColaborador.showModal = false
    },
    async closeModalSucesso() {
      this.modalSucesso.showModal = false;
      this.loadingData = true;

      await Promise.all([
        this.loadGroupQuantities(),
        this.loadGroupCollaborators()
      ]);

      this.loadingData = false;
    },
    toogleShowCollaboratorsAnotherGroup() {
      this.showFilter = false;

      this.clearSearch();

      this.filtering = true;
      this.paginationData.currentPage = 1;

      this.loadGroupCollaborators();
    },
    async buscaEstornosEmLote() {
      const idsPessoasFisicas = [...new Set(this.table.items.map(row => row.id_pessoa_fisica))];
      const idsParaBuscar = idsPessoasFisicas.filter(id => !this.dadosEstorno[id]);

      if (idsParaBuscar.length === 0) return;

      try {
        const res = await this.$http.get(this.$api.listaEstornos(idsParaBuscar, this.campaign.idCampaign));
        this.processarEstornos(res.data, idsParaBuscar);
      } catch (error) {
        console.error("Erro ao buscar estornos:", error);
      }
    },
    processarEstornos(estornos, idsParaBuscar) {
      if (!estornos || estornos.length === 0) {
        this.marcarIdsComoSemEstorno(idsParaBuscar);
        return;
      }

      const estornosAgrupados = this.agruparEstornos(estornos);
      this.atualizarDadosEstorno(estornosAgrupados);
    },
    agruparEstornos(estornos) {
      return estornos.reduce((acc, estorno) => {
        const estornoMapeado = {
          aplicacao: {
            nome_usuario_cancelamento: estorno.historico_usuario_cancelamento,
            data_cancelamento: estorno.historico_data_cancelamento,
            motivo_cancelamento: estorno.historico_motivo_cancelamento,
            descricao_dose: estorno.descricao_dose
          }
        };

        if (!acc[estorno.id_pessoa_fisica]) {
          acc[estorno.id_pessoa_fisica] = [];
        }

        acc[estorno.id_pessoa_fisica].push(estornoMapeado);
        return acc;
      }, {});
    },
    atualizarDadosEstorno(estornosAgrupados) {
      Object.entries(estornosAgrupados).forEach(([id, estornos]) => {
        this.$set(this.estornoStatus, id, true);
        this.$set(this.dadosEstorno, id, estornos);
      });
    },
    marcarIdsComoSemEstorno(ids) {
      ids.forEach(id => {
        this.$set(this.estornoStatus, id, false);
      });
    },
    validarMesmasDosesAplicadas(selected, dosesResults) {
      if (selected.length <= 1) {
        return true;
      }

      const dosesAplicadasPorColaborador = dosesResults.map(doses =>
        doses
          .filter(dose => dose.situacao === situacaoAplicacaoEnum.APLICADA || dose.situacao === situacaoAplicacaoEnum.FINALIZADA)
          .map(dose => ({
            id_dose: dose.id_dose,
            id_vacina: dose.id_vacina,
          }))
          .sort((a, b) => a.id_dose - b.id_dose)
      );

      const primeiraDoses = dosesAplicadasPorColaborador[0];

      if (!primeiraDoses || primeiraDoses.length === 0) {
        return dosesAplicadasPorColaborador.every(doses =>
          !doses || doses.length === 0
        );
      }

      return dosesAplicadasPorColaborador.every(doses => 
        doses.length === primeiraDoses.length &&
        doses.every((dose, index) =>
          dose.id_dose === primeiraDoses[index].id_dose &&
          dose.id_vacina === primeiraDoses[index].id_vacina
        )
      );
    },
    aoAlterarFiltroDeVacina() {
      this.loadDosesSelect(true)
      this.loadGroupQuantities()
    },
    async loadDosesSelect(clear) {
      if(clear){
        this.search.dose = null
        this.loadingDoses = true;
      }
      try {
        const response = await this.$http.get(this.$api.listarHistoricoDosesAplicadasPorCampanha(this.campaign.idCampaign), {
          params: {
            id_empresa: this.company?.idCompany ?? null,
            id_grupo: this.group?.idGroup ?? null,
            id_vacina: this.search.vacina?.id_vacina
          },
        });
        
        this.doseSelect = response.data;
        this.loadingDoses = false;

      } catch (error) {
        console.error("Erro ao carregar doses:", error);
        this.doseSelect = [];
      }
    },
    formatEndereco(endereco) { 
      return this.$helpers.formatEndereco(endereco); 
    },
    async selectMaiorGrupoConsistente(filtroSituacao, vacinaSelecionada = null) {
      let colaboradores = this.table.items.filter(filtroSituacao)

      if (vacinaSelecionada) {
        colaboradores = colaboradores.filter(colab =>
          colab.id_vacina === vacinaSelecionada.id_vacina
        )
      }

      if (!colaboradores.length) {
        this.closeModalConfirm()
        return []
      }

      const dosesResults = await Promise.all(
        colaboradores.map(colab => this.loadDosesColaborador(colab))
      )

      const grupos = {}

      colaboradores.forEach((colab, index) => {
        const dosesAplicadas = dosesResults[index]
          .filter(dose => dose.situacao === situacaoAplicacaoEnum.APLICADA || dose.situacao === situacaoAplicacaoEnum.FINALIZADA)
          .sort((a, b) => a.id_dose - b.id_dose);

        const assinatura = dosesAplicadas
          .map(dose => vacinaSelecionada
            ? dose.id_dose
            : `${dose.id_dose}-${dose.id_vacina}`
          )
          .join('-');

        if (!grupos[assinatura]) {
          grupos[assinatura] = []
        }
        grupos[assinatura].push(colab)
      })

      const maiorGrupo = Object.values(grupos).reduce((a, b) =>
        b.length > a.length ? b : a
      , [])

      this.table.items.forEach(item => { item.selected = false })
      maiorGrupo.forEach(colab => { colab.selected = true })

      this.multiSelect.count = maiorGrupo.length
      this.multiSelect.case = 'danger'

      this.$refs.tableVacinacao.refresh()
      this.verifyIfTwoStatesSelected()
      this.closeModalConfirm()

      return maiorGrupo
    },
    vacinaSelecionadaHandler(vacina) {
      this.vacinaSelecionada = vacina;
      this.selectAllVaccinated();
      this.vacinaSelecionada = null
    },
  }
}

</script>

<style scoped>
.font_size_label {
  font-size: 15px;
  margin-top: -5px;
}

.custom {
  padding: 5px 10px;
  margin-right: 10px;
  margin-bottom: 5px;
  font-weight: 400;
}

.button-icon {
    background: none;
    border: none;
    padding: 0;
    align-items: center;
}

.button-icon:focus {
    outline: none;
}

.cor_botao {
  color: #2772c0 !important;
  border: 1px solid #2772c0 !important;
}

.altura_max_scrollbar {
  max-height: 100px;
  padding-right: 15px;
}

.comprimento_maximo_celulas {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}

.comprimento_maximo_celulas_endereco {
  max-width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
}

.hidden_overflow_tabela {
  overflow: hidden;
}

#tableVacinacao >>> thead th {
  border-bottom: 2px solid #2772c0 !important;
  background-color: #2772c0 !important;
  color: white;
}

.bg-blue {
  background-color: #f2f7fc;
}

.id-empresa-aplicadora {
  width: 100%;
  text-align: left;
  display: inline-block;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  border-color: none !important;
  background-color: none !important;
}

.span-descricao-campanha {
  background: #F5F6F9;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: right;
  margin-top: 0;
}

.span-descricao-empresa {
  flex: 1;
}

.h2-descricao-empresa-campanha {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.custom-switch-visual {
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

.custom-switch-visual >>> .custom-control {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.custom-switch-visual >>> .custom-switch {
  padding-left: 0 !important;
}

.custom-switch-visual >>> .custom-control-label::before,
.custom-switch-visual >>> .custom-control-label::after,
.custom-switch-visual >>> input[type='checkbox'] {
  display: none !important;
  width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

.custom-switch-visual >>> .custom-control-label {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 130px;
  border-radius: 20px;
  text-align: center;
  padding: 0 !important;
  margin: 0 !important;
  margin-left: 0 !important;
}

.custom-switch-visual.custom-switch-success >>> .custom-control-label {
  background-color: #e5f8ed !important;
  font-weight: bold;
  color: #28c76f;
}

.custom-switch-visual.custom-switch-danger >>> .custom-control-label {
  background-color: #fceaea !important;
  font-weight: bold;
  color: #ea5455;
}

.custom-switch-visual.custom-switch-primary >>> .custom-control-label {
  background-color: #e5eef7 !important;
  font-weight: bold;
  color: #4c75b7;
}

.custom-switch-visual.custom-switch-secondary >>> .custom-control-label {
  background-color: #eaeaed !important;
  font-weight: bold;
  color: #6e6b7b;
}

.button-wrapper {
  display: inline-block;
}

.action-button {
  opacity: 1;
  cursor: pointer;
}

.action-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.vaccine-icon {
  width: 18px;
  height: 18px;
  transform: scaleX(-1);
}

#endereco-input.vs--open >>> .vs__search {
  line-height: 1.4rem;
  min-height: 3.7rem;
}

@media (max-width: 1700px) {
  #endereco-input.vs--open >>> .vs__search {
    min-height: 7rem;
  }
}

#endereco-input >>> .vs__dropdown-option {
  white-space: normal;
  line-height: 1.3rem;
  word-break: break-word;
}

</style>
